import React from 'react'
import { useState } from "react"

export default function Textform(props) {
  const handlecopy =()=>{
    console.log("text is copied")
    let text=document.getElementById('mybox')
    text.select()
    text.setSelectionRange(0,9999)
    navigator.clipboard.writeText(text.value)
    props.showalert("Copied to clipboard" ,"success")
  }

  const handleclear =()=>{
    console.log("text is clear")
    setText("")
    props.showalert("Cleared the text area" ,"success")
  }

  const handleUpclick =()=>{
    console.log("Uppercase was clicked")
    let newtext = text.toUpperCase();
    setText(newtext)
    props.showalert("Converted into Uppercase!" ,"success")
  }

  const handlelowclick =()=>{
    console.log("Uppercase was clicked")
    let newtext = text.toLowerCase();
    setText(newtext)
    props.showalert("Converted into lowercase!" ,"success")
  }

  const handleOnchange =(event)=>{
    console.log("Onchange click")
    setText(event.target.value)
  }

  const handleextraspces=()=>{
    let newtext=text.split(/[ ]+/);
    setText(newtext.join(" "))
    props.showalert("Space is cleard" ,"Success")
  }
  const[text, setText] =useState('')
  return (
    <div>
      <div className="container"  style={{color : props.mode==='dark'?'white':'black' }}>


        <h1>{props.heading}</h1>
        <div className="mb-3">
            <textarea className="form-control" value={text}  onChange={handleOnchange} style={{backgroundColor : props.mode==='dark'?'#828282':'white' , color: props.mode==='dark'?'white':'black'}} id="mybox" rows="8"></textarea>
        </div>
        <button  disabled={text.length===0} type="button" className="btn btn-primary mx-1 my-1" onClick={handleUpclick}>Convert Uppercase</button>
        <button disabled={text.length===0} type="button" className="btn btn-primary mx-1 my-1" onClick={handlelowclick}>Convert Lowercase</button>
        <button disabled={text.length===0} type="button" className="btn btn-primary mx-1 my-1" onClick={handleclear}>Clear Text</button>
        <button disabled={text.length===0} type="button" className="btn btn-primary mx-1 my-1" onClick={handlecopy}>Copy Text</button>
        <button disabled={text.length===0} type="button" className="btn btn-primary mx-1 my-1" onClick={handleextraspces}>Clear Extra Space</button>

        </div>
        <div className="container my-3" style={{color : props.mode==='dark'?'white':'black' }}>
          <h2>Your text summary</h2>
          <p>{text===''?0:text.split(/\s/).filter((element)=>{return element.length!==0}).length} words and {text.length} characters</p>
          <p>{0.008*text.split(" ").filter((element)=>{return element.length!==0}).length} Minutes to read</p>
          <h2>Preview</h2>
          <p>{text.length>0?text:"Write something in the box to preview"}</p>
        </div>
    </div>
  )
}
